module.exports = __webpack_public_path__ + "static/media/icon-checkmark.ee1a3e3f.svg";